export default __webpack_public_path__ + "static/image7-d7b4e696384f0d75643de4a945e79be7.jpg";